import type { NomenclatureExtendedInterface } from '@/types'
import api from '@/utils/api/api'

import type { NomenclatureCreationRequest } from '../lib/singularImportRequest'

export type CreatedNomenclature = Pick<
  NomenclatureExtendedInterface,
  | 'id'
  | 'parentModel'
  | 'code'
  | 'description'
  | 'article'
  | 'brandDto'
  | 'categoryDto'
  | 'unitOfMeasurementDto'
  | 'countryDto'
>

type CreateNomenclatureResponse = { nomenclature: CreatedNomenclature }

export const singularImportApi = {
  createNomenclature: async (payload: NomenclatureCreationRequest) => {
    const { data } = await api.post<CreateNomenclatureResponse>(
      '/main/nomenclatures',
      payload,
      { headers: { 'Region-Bank': 'NBRB' } }
    )
    return data.nomenclature
  },
}
